import { ECurecallNotificationAppearance } from '@honestica/curecall-ui'
import { useQueryClient } from '@tanstack/react-query'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useNotification } from 'src/providers/notification.provider'
import { getErrorMessage } from 'src/utils/http.util'

type TSubmitPlanningTabMessages = {
  successTitle: string
  successMessage: string
  errorTitle: string
}

// Saves the tab, refreshes the project, then notifies the user of the outcome
export const useSubmitPlanningTab = <TResult, TValues>(
  save: (values: TValues) => Promise<TResult>,
  messages: TSubmitPlanningTabMessages,
  onSuccess: (savedTab: TResult) => void,
) => {
  const { project } = useCurrentProject()
  const queryClient = useQueryClient()
  const { notify } = useNotification()

  return async (values: TValues) => {
    try {
      const savedTab = await save(values)
      await queryClient.invalidateQueries({ queryKey: ['project', project.id] })
      notify(
        {
          title: messages.successTitle,
          message: messages.successMessage,
          appearance: ECurecallNotificationAppearance.SUCCESS,
        },
        15000,
      )
      onSuccess(savedTab)
    } catch (error) {
      notify(
        {
          title: messages.errorTitle,
          message: getErrorMessage(error),
          appearance: ECurecallNotificationAppearance.ERROR,
        },
        15000,
      )
    }
  }
}
